// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonsBubble__bubble-ed8e77 {
  width: var(--message-bubble-max-width);
  border: none;
  padding: 0;
  border-radius: 0;
  background-color: transparent;
}

.ButtonsBubble__header-b03bbd {
  border-radius: 16px 16px 4px 4px;
  padding: 8px 12px;
  background-color: var(--base-17);
  margin-bottom: 2px;
}

.ButtonsBubble__header-b03bbd.ButtonsBubble__my-header-e76356 {
  background-color: var(--addition-150);
}

.ButtonsBubble__header-b03bbd:after {
  content: "";
  display: table;
  clear: both;
}

.ButtonsBubble__sender-name-ec7a82 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ButtonsBubble__sender-name-ec7a82.ButtonsBubble__wide-gap-b56933 {
  margin-bottom: 4px;
}

.ButtonsBubble__quote-e2382a {
  margin-bottom: var(--indent-8px);
}

.ButtonsBubble__forward-e01278 {
  margin-bottom: var(--indent-8px);
}

.ButtonsBubble__status-bar-a8782c {
  float: right;
  margin-top: 4px;
  margin-inline-start: var(--indent-8px);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ButtonsBubble/ButtonsBubble.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,gCAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,sCAAA;AACF","sourcesContent":[".bubble {\n  width: var(--message-bubble-max-width);\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  background-color: transparent;\n}\n\n.header {\n  border-radius: 16px 16px 4px 4px;\n  padding: 8px 12px;\n  background-color: var(--base-17);\n  margin-bottom: 2px;\n}\n\n.header.my-header {\n  background-color: var(--addition-150);\n}\n\n.header:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sender-name.wide-gap {\n  margin-bottom: 4px;\n}\n\n.quote {\n  margin-bottom: var(--indent-8px);\n}\n\n.forward {\n  margin-bottom: var(--indent-8px);\n}\n\n.status-bar {\n  float: right;\n  margin-top: 4px;\n  margin-inline-start: var(--indent-8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `ButtonsBubble__bubble-ed8e77`,
	"header": `ButtonsBubble__header-b03bbd`,
	"my-header": `ButtonsBubble__my-header-e76356`,
	"myHeader": `ButtonsBubble__my-header-e76356`,
	"sender-name": `ButtonsBubble__sender-name-ec7a82`,
	"senderName": `ButtonsBubble__sender-name-ec7a82`,
	"wide-gap": `ButtonsBubble__wide-gap-b56933`,
	"wideGap": `ButtonsBubble__wide-gap-b56933`,
	"quote": `ButtonsBubble__quote-e2382a`,
	"forward": `ButtonsBubble__forward-e01278`,
	"status-bar": `ButtonsBubble__status-bar-a8782c`,
	"statusBar": `ButtonsBubble__status-bar-a8782c`
};
module.exports = ___CSS_LOADER_EXPORT___;
